import homeModule from '@/modules/home/pages/index.vue';

export default [
  {
    path: '',
    component: homeModule,
    name: 'home',
  },
];
